import { useMemo } from 'react';
import { get } from 'lodash';
import { ChipProps } from '@mui/material';

import { RouteItemStateType } from '~globals/types/enums';

interface OrderFinalizedStateInfoItem {
  description: string;
  color: NonNullable<ChipProps['color']>;
  tooltipMessage: string;
}

type OrderFinalizedStateType =
  | RouteItemStateType.FinalizedSuccess
  | RouteItemStateType.FinalizedError
  | RouteItemStateType.WithoutVisiting;

type OrderFinalizedStateList = {
  [state in OrderFinalizedStateType]: OrderFinalizedStateInfoItem;
};

export const useOrderFinalizedStateInfo = (
  stateId: OrderFinalizedStateType,
): OrderFinalizedStateInfoItem => {
  const stateList = useMemo<OrderFinalizedStateList>(
    () => ({
      [RouteItemStateType.FinalizedSuccess]: {
        description: 'Completa',
        color: 'success',
        tooltipMessage: 'Entregada correctamente.',
      },
      [RouteItemStateType.FinalizedError]: {
        description: 'Incompleta',
        color: 'error',
        tooltipMessage: 'No pudo completarse.',
      },
      [RouteItemStateType.WithoutVisiting]: {
        description: 'Cierre forzoso',
        color: 'warning',
        tooltipMessage: 'Pendiente debido al cierre forzoso de la ruta.',
      },
    }),
    [],
  );

  const currentInfo = useMemo<OrderFinalizedStateInfoItem>(
    () => get(stateList, stateId),
    [stateId, stateList],
  );

  return currentInfo;
};
